import PropTypes from 'prop-types'
import React from 'react'
import { PageHeader, Page404 } from 'src/ui/index'
import { connect } from 'react-redux'
import { getHasAgents } from '../../../selectors'
import { AgentsContainer } from '../../Agents'

const Agents = ({ hasAgents }) => {
  return hasAgents ? (
    <React.Fragment>
      <PageHeader key='header'>Agenti</PageHeader>

      <AgentsContainer key='agents-container' />
    </React.Fragment>
  ) : <Page404 />
}

const mapStateToProps = state => {
  return {
    hasAgents: getHasAgents(state)
  }
}

Agents.propTypes = {
  hasAgents: PropTypes.bool.isRequired
}

Agents.defaultProps = {
}

export default connect(mapStateToProps)(Agents)
